"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
var _wechat = require("@/libs/wechat");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 标记是否正在跳转登录页，防止重复跳转
var isRedirectingToLogin = false;
var service = _axios.default.create({
  baseURL: _settingMer.default.apiBaseURL,
  timeout: 60000 // 过期时间
});

// request interceptor
service.interceptors.request.use(function (config) {
  // 发送请求之前做的
  var token = !_store.default.getters.token ? sessionStorage.getItem('token') : _store.default.getters.token;
  config.headers['X-Source'] = 'df07addc462f7f8f';
  if (token) {
    config.headers['Authori-zation'] = token;
  }
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params.temp = Date.parse(new Date()) / 1000;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  // 如果是 blob 类型（文件下载），直接返回
  if (response.config.responseType === 'blob') {
    return response.data;
  }
  var res = response.data;
  // if the custom code is not 20000, it is judged as an error.
  if (res.code === 401) {
    // to re-login
    // 防止网络差时多个并发请求同时返回 401 导致重复跳转
    if (!isRedirectingToLogin) {
      isRedirectingToLogin = true;
      _elementUi.Message.error('无效的会话，或者登录已过期，请重新登录。');
      setTimeout(function () {
        if (window.location.pathname !== '/login') {
          location.href = '/login';
        }
      }, 300);
    }
  } else if (res.code === 403) {
    _elementUi.Message.error('没有权限访问。');
  }
  if (res.code !== 200 && res.code !== 401) {
    if ((0, _wechat.isPhone)()) {
      //移动端
      return Promise.reject(res || 'Error');
    }
    (0, _elementUi.Message)({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject();
  } else {
    return res.data;
  }
}, function (error) {
  // 网络错误处理 - 区分真正的错误和网络波动
  if (error.message) {
    var errorMsg = error.message.toLowerCase();
    // 网络超时或断开连接时，不显示错误提示，避免误判
    if (errorMsg.includes('timeout') || errorMsg.includes('network') || errorMsg.includes('connection')) {
      console.warn('网络请求失败:', error.message);
    } else {
      (0, _elementUi.Message)({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      });
    }
  }
  return Promise.reject(error);
});
var _default = exports.default = service;